// C.1 — общая утилита mind-control (угон вражеского юнита на свою сторону).
//
// Извлечено из abilities/deus/kirosa-active.js (Кироса активка).
// Используется любыми эффектами mind_control: Двойной агент, Перевербовка,
// Захват контракта, Вражд. поглощение, Лиза активка (livlife_lisa).
//
// Поведение (диздок 6.6 «карты, призванные не из руки»):
//   - убрать с поля бывшего владельца БЕЗ обработчиков смерти;
//   - перенести Card-инстанс на свободную ячейку нового владельца;
//   - ownerId = newOwnerIdx, initiation = 0 (активен сразу);
//   - placedTurn = state.currentTurn;
//   - HP, броня (current), keywords, persistent-баффы — переносятся как есть;
//   - пересчёт ауры Второго директора + Подкрепления + line-triggers.
//
// API:
//   mindControlUnit(state, newOwnerIdx, card, slot = null)
//     - card — Card-инстанс на поле текущего владельца.
//     - slot — { line, slot } целевая ячейка. Если null — выбирается первая свободная.
//     - Возвращает { ok, slot } | { ok: false, reason }.

import { recomputeDirectorAura } from '../abilities/deus/vtoroy-direktor.js';
import { recomputeReinforcement } from '../keywords/reinforcement.js';
import { recomputeLineTriggers } from '../keywords/line-triggers.js';

export function mindControlUnit(state, newOwnerIdx, card, slot = null) {
  if (!state || newOwnerIdx == null || !card) return { ok: false, reason: 'no_args' };
  const newOwner = state.players?.[newOwnerIdx];
  if (!newOwner) return { ok: false, reason: 'no_player' };
  if (card.type !== 'unit') return { ok: false, reason: 'not_unit' };
  if (card.isAlive && !card.isAlive()) return { ok: false, reason: 'dead' };

  // Найти свободный слот если не задан.
  if (!slot) {
    if (!newOwner.field) return { ok: false, reason: 'no_field' };
    outer: for (let line = 0; line < 2; line++) {
      const row = newOwner.field[line];
      if (!row) continue;
      for (let s = 0; s < row.length; s++) {
        if (row[s] === null) { slot = { line, slot: s }; break outer; }
      }
    }
    if (!slot) return { ok: false, reason: 'no_free_slot' };
  }
  if (slot.line < 0 || slot.line > 1 || slot.slot < 0 || slot.slot > 3) {
    return { ok: false, reason: 'invalid_slot' };
  }
  if (newOwner.field[slot.line][slot.slot] !== null) {
    return { ok: false, reason: 'slot_occupied' };
  }

  // Снять с поля старого владельца.
  const oldOwnerIdx = card.ownerId;
  if (oldOwnerIdx != null && oldOwnerIdx !== newOwnerIdx) {
    const oldOwner = state.players[oldOwnerIdx];
    const oldLine = card.line, oldSlot = card.slot;
    if (oldOwner?.field?.[oldLine]?.[oldSlot] === card) {
      oldOwner.field[oldLine][oldSlot] = null;
    }
  }

  card.line = null;
  card.slot = null;
  card.initiation = 0;
  card.placedTurn = state.currentTurn;
  card.ownerId = newOwnerIdx;
  card.side = 'owner';
  // Спящий агент не захватывается отдельно — этот хук на всякий случай.
  card.sleeperState = null;
  // Силенс на угнанном — снимаем (по диздоку: «свежий» при выставлении не из руки).
  if (card.silenceSources && typeof card.silenceSources.clear === 'function') {
    card.silenceSources.clear();
  }
  if (card.current) card.current.silenced = false;

  try {
    newOwner.placeCard(card, slot.line, slot.slot);
  } catch (e) {
    return { ok: false, reason: 'place_failed' };
  }
  card.ownerId = newOwnerIdx;

  if (state.log) {
    state.log.add(
      `🎯 Угон: «${card.name_ru || card.id}» → [${newOwner.name}] на л.${slot.line + 1}, сл.${slot.slot + 1}`
    );
  }

  // Пересчёт всех аур, зависящих от состава поля.
  try { recomputeDirectorAura(state); } catch {}
  try { recomputeReinforcement(state); } catch {}
  try { recomputeLineTriggers(state); } catch {}

  return { ok: true, slot };
}
